<template>
  <div class="base-container-frame">
    <el-container>
      <el-aside width="auto">
        <zwx-scrollbar-y style="height: 100%;">
          <!-- 原菜单 -->
          <side-menu ref="menuAside" @menuSelectHandler="menuSelectHandler" :init-menu="initMenu" />
          <!-- 头部存在横向一级菜单时的层级菜单 -->
        </zwx-scrollbar-y>
      </el-aside>
      <el-main>
        <page-frame ref="pageFrame" @tabSelect="tabSelect" @menuJump="menuJump" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "BaseContainer",
  props: {
    initMenu: { type: String },
  },
  methods: {
    menuJump(name) {
      this.$refs.menuAside.menuSelect(name);
    },
    //菜单选择切换tab
    menuSelectHandler(name, title, content, refresh) {
      this.$refs.pageFrame.menuTabs(name, title, content, refresh);
    },
    //tab选择切换菜单选中状态
    tabSelect(name) {
      this.$refs.menuAside.tabMenu(name);
    }
  }
};
</script>
